import { render } from "./ProductShow.vue?vue&type=template&id=d2226d22"
import script from "./ProductShow.vue?vue&type=script&lang=js"
export * from "./ProductShow.vue?vue&type=script&lang=js"

import exportComponent from "C:\\frotend\\d7m_front_end\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__